var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:"form",attrs:{"disabled":_vm.disabled,"label-width":_vm.labelWidth},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("navbar"),_c('el-row',{attrs:{"gutter":30}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"box"},[_vm._t("box")],2)])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }